import { TableHeadersType } from "../tableHeadersType";

export const DISBURSEMENT_HEADER:TableHeadersType[]=[
    {
        label: 'Title',
        value: 'title',
        checked: true,
        defaultChecked: true
      },
      {
        label: 'Client Name',
        value: 'client_name',
        checked: true,
        defaultChecked: true
      },
      {
        label: 'Job Type (Job Id)',
        value: 'job_type',
        checked: true,
        defaultChecked: true
      },
      {
        label: 'Payment Date',
        value: 'payment_date',
        checked: true,
        defaultChecked: true
      },
      {
        label: 'Total Amount',
        value: 'amount',
        checked: true,
        defaultChecked: true
      },
      {
        label: 'Payment Description',
        value: 'payment_description',
        checked: true,
        defaultChecked: true
      },
      {
        label: 'Attachments',
        value: 'attachments',
        checked: true,
        defaultChecked: true
      },
      {
        label: 'Created By',
        value: 'created_at',
        checked: true,
        defaultChecked: true
      },
      {
        label: 'Modified By',
        value: 'updated_at',
        checked: true,
        defaultChecked: true
      },
      {
        label: 'Approved By',
        value: 'approved_by',
        checked: true,
        defaultChecked: true
      },
      {
        label: 'Payment Status',
        value: 'payment_status',
        checked: true,
        defaultChecked: true
      },
      {
        label: 'Edit',
        value: 'edit',
        checked: true,
        defaultChecked: true
      }
]